/*
 * Created by Vladimir Shishlyannikov on 22/09/2022.
 * Copyright (c) 2022 iWoo Ltd. All rights reserved.
 */
// package com.trubeapp.application.partner.availabilityview;

// import android.annotation.TargetApi;
// import android.content.Context;
// import android.content.res.ColorStateList;
// import android.content.res.Resources;
// import android.graphics.Canvas;
// import android.graphics.Paint;
// import android.graphics.Typeface;
// import android.os.Build;
// import android.support.annotation.Nullable;
// import android.text.TextPaint;
// import android.view.MotionEvent;
// import android.view.View;
// import android.view.ViewConfiguration;
// import android.util.AttributeSet;
// import android.widget.TextView;

// import com.trubeapp.android.client.resource.DayAvailability;
// import com.trubeapp.application.partner.R;

// import java.text.NumberFormat;
// import java.text.SimpleDateFormat;
// import java.util.Calendar;
// import java.util.List;
// import java.util.Locale;


import React, { PropsWithChildren } from 'react';
import PropTypes from 'prop-types'; // use directly
// import clsx from 'clsx';
// import BackgroundSelectionHeader from './BackgroundSelectionHeader/BackgroundSelectionHeader';
// import BackgroundThumbnail from './BackgroundThumbnail/BackgroundThumbnail';
// import Drawer from '@material-ui/core/Drawer';
import { makeStyles, Theme } from '@material-ui/core/styles';
// import { backgroundConfig } from '../VideoProvider/useBackgroundSettings/useBackgroundSettings';

// const createReactClass = require('create-react-class');
// const PropTypes = require('prop-types');
// const cn = require('classnames');

// import AvailabilityView from '../AvailabilityView/AvailabilityView'; // './CalendarCell';
// import CalendarCellView from '../CalendarCellView/CalendarCellView'; // './CalendarCell';
import * as dates from  '../../../utils/dates';
import { date as dateLocalizer } from '../../../utils/localizers';

// import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

/**
 * The number of days (ex. 28) in the current month.
 */
// const daysInMonth = 30;

const useStyles = makeStyles((theme: Theme) => ({
  // drawer: {
  //   display: 'flex',
  //   width: theme.rightDrawerWidth,
  //   height: `calc(100% - ${theme.footerHeight}px)`,
  // },
  // thumbnailContainer: {
  //   display: 'flex',
  //   'flex-wrap': 'wrap',
  //   padding: '5px',
  //   'overflow-y': 'auto',
  // },
  // apNavView: {
  //   // table {
  //   'border-collapse': 'collapse',
  //   // }
  // },
  // apCalendarGrid: {
  //   width: '100%',
  //   height: 'auto',
  //   'border-collapse': 'collapse',
  // },
  // apCalendarRow: {
  // // tr {
  //   'border-bottom': '1pt solid rgb(203, 207, 213)',
  // // }
  // },
  apHeadCell: {
    'font-family': "'Poppins', Arial, sans-serif",
    'font-weight': 400,
    'font-size': '12px',
    'text-align': 'center',
    'text-transform': 'uppercase',
    color: theme.greyInactive, // #CBCFD5 // '#6b7178',
    // .rw-cell, .rw-head-cell {
    // text-align: center;
    padding: '0',
    border: '0',
    // 'padding-bottom': '1px',
    // }
  },
}));

interface MonthHeaderProps {
  // disabled?: boolean;
  className?: string;
  // today?: Date;
  week: Date[];
  format: string;
  // value?: Date;
  // focused?: Date;
  culture?: string;
  // activeId?: string;
  // availableDays?: object[];
  // minDate?: Date;
  // maxDate?: Date;
  // dayComponent?: any;
  // dayFormat?: string;
  // dateFormat?: string;
  // // sessionType: string;
  // // onClick(): void;
  // // onClose(): void;
  // highlightedDays: number[],
  // hasBookingsDays: number[],
  // onChange(date: Date): void;
}

/**
 * Displays a list of months in a calendar format with selectable days.
 */


function MonthHeader({
  // disabled,
  className,
  week,
  format,
  culture,
  // today,
  // value,
  // focused,
  // activeId,
  // availableDays,
  // minDate,
  // maxDate,
  // dayComponent,
  // dayFormat,
  // dateFormat,
  // highlightedDays,
  // hasBookingsDays,
  // onChange,
}: PropsWithChildren<MonthHeaderProps>) {
  const classes = useStyles();

  const firstOfWeek = dateLocalizer.firstOfWeek(culture);

  return (
    <>
    {week?.map((date: Date) => (
      <th
        className={classes.apHeadCell/*, 'ap-head-cell')*/}
        key={'header_' + dates.weekday(date, undefined, firstOfWeek)}
      >
        <div>{dateLocalizer.format(date, format, culture)}</div>
      </th>
    ))}
    </>
  );

}

MonthHeader.propTypes = {
  // activeId: PropTypes.string,
  // disabled: PropTypes.bool,
  week: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
  // today: PropTypes.instanceOf(Date),
  format: PropTypes.string,
  culture: PropTypes.string,
  // value: PropTypes.instanceOf(Date),
  // focused: PropTypes.instanceOf(Date),
  /**
   * Available days of the week. If not present then it will be disabled.
   *
   * @example ['prop', ['availableDays', '['2018-11-03', ..]']]
   */
  // availableDays: PropTypes.array,
  // minDate: PropTypes.instanceOf(Date),
  // maxDate: PropTypes.instanceOf(Date),
  // onChange: PropTypes.func.isRequired,

  // dayComponent: PropTypes.object, // CustomPropTypes.elementType,
  // dayFormat: PropTypes.object,
  // dateFormat: PropTypes.string, // CustomPropTypes.dateFormat
  // // footerFormat: PropTypes.string,

};

export default React.memo(MonthHeader);
